module.exports = "/../../dist/frontend/images/manuel.webp?2f28035dd34348e6a4e6c18792354742";